import { Material } from '@sp-types/materialType';
import { Product } from '@sp-types/productType';
import React from 'react';
import ButtonDesigned from '../../../../components/UI-Elements/Buttons/ButtonDesigned';
import { DoughnutItem, DoughnutLegendLines } from './DoughnutLegendLines';

interface Props {
  material: Material;
  onClickAddProduct: () => void;
  products?: Product[];
  colors: Record<string, string>;
}
export const MaterialProducts: React.FC<Props> = ({ material, products, colors, onClickAddProduct }) => {
  return material && products?.length ? (
    <div className="flex flex-col gap-2 p-3 text-base  ">
      <div className="flex flex-row text-lg justify-between">
        <p>Material products</p>
        <ButtonDesigned
          className="px-1 py-[2px] "
          onButtonClick={() => {
            onClickAddProduct();
          }}
          style="outline"
        >
          Add product
        </ButtonDesigned>
      </div>
      <div className=" flex flex-1 flex-col justify-center ">
        <DoughnutLegendLines subTitle="Total weight" items={getItems(products, material.id, colors)} />
      </div>
    </div>
  ) : products?.length === 0 ? (
    <div className="flex flex-col justify-center h-full p-3">No products with selected material</div>
  ) : (
    <RoundSkeleton />
  );
};

const RoundSkeleton: React.FC = () => (
  <div className="mx-auto my-6 w-52 h-52 bg-gray-100 animate-pulse rounded-full"></div>
);

const getItems = (products: Product[], materialId: string, colors: Record<string, string>): DoughnutItem[] =>
  products.map(({ ingredients, name }) => ({
    name,
    quantity: ingredients.find(({ materialID }) => materialID === materialId)?.weightInProduct || 1,
    color: colors[materialId],
  }));
